export default __webpack_public_path__ + "static/media/Boots of Courageous Souls.ec0d3e15.jpg";